export default "__VITE_ASSET__XgVLRUsN__"